var render, staticRenderFns
import script from "./KycNotComplete.vue?vue&type=script&lang=js"
export * from "./KycNotComplete.vue?vue&type=script&lang=js"
import style0 from "./KycNotComplete.vue?vue&type=style&index=0&id=6a226e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a226e52",
  null
  
)

export default component.exports